module.exports = __webpack_public_path__ + "img/green-arrow-right.7edb606.png";